// @flow
import React, { Component } from 'react';

import Avatar from 'material-ui/Avatar';
import FontIcon from 'material-ui/FontIcon';

import IconButton from 'material-ui/IconButton';
import RaisedButton from 'material-ui/RaisedButton';
import Toggle from 'material-ui/Toggle';
import { CardHeader } from 'material-ui/Card';

import { getFeatureColor } from 'utils/mapStyle';
import { isFeatureDisabled } from 'utils/auth';

import {
  AIRSPACE_TYPE_LABELS,
  AIRSPACE_USE_TYPES,
  AIRCRAFT_TYPES,
} from 'utils/propSheet';

const getStyles = ({ feature, isMobile, hasSubscription }) => ({
  header: {
    backgroundColor: getFeatureColor(feature),
  },

  title: {
    color: 'white',
    paddingTop: feature.type === 's' && !isMobile ? 12 : 3,
  },

  subtitle: {
    color: 'rgba(255, 255, 255, .7)',
  },

  avatar: {
    backgroundColor: 'white',
    color: getFeatureColor(feature),
  },

  detailsButton: {
    position: 'absolute',
    top: 18,
    right: hasSubscription ? 96 : 62,
  },

  followToggle: {
    position: 'absolute',
    top: 15,
    right: 62,
    maxWidth: 100,
    background: 'white',
    padding: '8px 16px',
    borderRadius: 50,
  },

  notamDetailsButtonLabel: {
    color: getFeatureColor({ style_category: 'temporary' }),
  },

  searchDetailsButtonLabel: {
    color: getFeatureColor({ style_category: 'search' }),
  },

  closeButton: {
    position: 'absolute',
    top: 12,
    right: 12,
  },

  saveTemplateButton: {
    position: 'absolute',
    top: 12,
    right: 48,
  },
});

const renderTitle = (feature, isMobile) => {
  switch (feature.type) {
    case 'as':
    case 'ap':
      return feature.name;

    case 's':
      return isMobile ? (
        <span>
          Mentett<br />keresés
        </span>
      ) : (
        'Mentett keresés'
      );

    case 'ac':
      return feature.name || feature.address || <em>Ismeretlen</em>;
  }
};

const renderSubtitle = feature => {
  switch (feature.type) {
    case 'as':
      return feature.style_category === 'inventory'
        ? 'Beadott esetilégtér-igénylés'
        : AIRSPACE_TYPE_LABELS[feature.airspace_type];

    case 'ap':
      return feature.designation || 'Repülőtér';

    case 's':
      return null;

    case 'ac':
      return AIRCRAFT_TYPES[feature.aircraft_type].label;
  }
};

const renderAvatarIcon = feature => {
  switch (feature.type) {
    case 'as':
      if (feature.use_type in AIRSPACE_USE_TYPES) {
        return AIRSPACE_USE_TYPES[feature.use_type].icon;
      }
      return (
        <FontIcon className="material-icons" size={12}>
          flight
        </FontIcon>
      );

    case 'ap':
      return (
        <FontIcon className="material-icons" size={12}>
          flight_takeoff
        </FontIcon>
      );

    case 's':
      return (
        <FontIcon className="material-icons" size={12}>
          search
        </FontIcon>
      );

    case 'ac':
      return AIRCRAFT_TYPES[feature.aircraft_type].icon;
  }
};

export default ({
  feature,
  followedAircraft,

  onSearchDetailsClick,
  onNotamDetailsClick,
  onSetFollowedAircraft,
  onClose,
  onSaveTemplateClick,

  isMobile,
  isExpanded,
  expandable,
  hasSubscription,
}) => {
  if (!feature) {
    return null;
  }

  const styles = getStyles({ feature, isMobile, hasSubscription });

  return (
    <CardHeader
      title={renderTitle(feature, isMobile)}
      titleStyle={styles.title}
      subtitle={renderSubtitle(feature)}
      subtitleStyle={styles.subtitle}
      avatar={
        <Avatar
          style={styles.avatar}
          color={styles.avatar.color}
          icon={renderAvatarIcon(feature)}
        />
      }
      style={styles.header}
    >
      {(feature.type === 's' || (feature.type === 'as' && feature.source == 'NOTAM' && hasSubscription) &&
          !isFeatureDisabled('notam_details')) && (
        <RaisedButton
          label="Részletek"
          labelStyle={
            feature.type === 's'
              ? styles.searchDetailsButtonLabel
              : styles.notamDetailsButtonLabel
          }
          style={styles.detailsButton}
          onClick={() =>
            feature.type === 's'
              ? onSearchDetailsClick()
              : onNotamDetailsClick()
          }
          containerElement="label"
        />
      )}
      {feature.type === 'ac' &&
        feature.aircraft_type !== 'ground-station' && (
          <Toggle
            label="Követés"
            labelStyle={{ color: 'black', fontSize: 13 }}
            toggled={feature.id === followedAircraft}
            style={styles.followToggle}
            onClick={() =>
              onSetFollowedAircraft(
                feature.id === followedAircraft ? null : feature.id
              )
            }
            labelPosition="left"
          />
        )}
      {['NOTAM', 'INVENTORY'].includes(feature.source) && !isFeatureDisabled('saved_templates') && (
        <IconButton
          tooltip="Mentés sablonként"
          style={styles.saveTemplateButton}
          onClick={onSaveTemplateClick}
        >
          <FontIcon className="material-icons" color="white">
            save
          </FontIcon>
        </IconButton>
      )}
      <IconButton tooltip="Bezár" style={styles.closeButton} onClick={onClose}>
        <FontIcon className="material-icons" color="white">
          {expandable
            ? isExpanded
              ? 'keyboard_arrow_down'
              : 'keyboard_arrow_up'
            : 'close'}
        </FontIcon>
      </IconButton>
    </CardHeader>
  );
};



// WEBPACK FOOTER //
// ./components/PropSheet/Header.js